import { Routes, BrowserRouter, Route, Navigate, Link } from "react-router-dom";
import { PrismicProvider, PrismicToolbar } from "@prismicio/react";

import { client, repositoryName } from "./prismic";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Blog } from "./pages/Blog";
import { Intrebari } from "./pages/Intrebari";
import { NotFound } from "./pages/NotFound";
import { Post } from "./pages/Post";
import { Preview } from "./pages/Preview";
import { Sitemap } from "./pages/Sitemap";

/**
 * Main app component
 */
export const App = () => {
  return (
    <PrismicProvider
      client={client}
      internalLinkComponent={({ href, ...props }) => (
        <Link to={href} {...props} />
      )}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/despre-noi" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/sensus-intreaba/:uid" element={<Intrebari />} />
          <Route path="/blog/:uid" element={<Post />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      {/* <PrismicToolbar repositoryName={repositoryName} /> */}
    </PrismicProvider>
  );
};
